/**
 * Created by jerry on 2017/6/9.
 */
import axios from 'axios'
import qs from 'qs'
import {
  bus
} from '../bus.js'
import {
  Toast
} from "vant";
import {
  Indicator
} from 'mint-ui';

axios.defaults.withCredentials = true
axios.defaults.timeout = 30000

Promise.prototype.done = function (fn) {
  this.then(resp => {
    if (resp.ret !== 1) {
      Toast({
        message: resp.data || resp.msg || '网络出现异常，请稍后再试',
        duration: 3000
      })
    }
    typeof fn == "function" && resp.ret == 1 && fn(resp);
  })
  return this;
}


// 添加请求拦截器
// axios.interceptors.request.use(function (connfig) {
// 在发送请求之前做些什么
// let version = getVersion()
// console.log(connfig))
// eslint-disable-next-line no-irregular-whitespace
// 　　return config
// }, function (error) {
// 对请求错误做些什么
// return Promise.reject(error)
// });
//拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    return response
  },
  error => {
    console.log(error.response)
    if (error.response.status.toString().charAt(0) == '5') {
      Toast({
        message: '服务器正在维护，请稍后再试',
        duration: 2000
      })
      setTimeout(() => {
        bus.$emit('goto', '/login')
      }, 2000);
      $indicator.close();
    } else {
      Toast({
        message: error.response.data.data || '请求失败',
        duration: 2000
      })
      setTimeout(() => {
        // bus.$emit('goto', '/login')
        top.location = "/login";
      }, 2000);
      Indicator.close();
    }
    // if (error.response.status == '504') {
    //   Toast({
    //     message: '服务器正在维护，请稍后再试',
    //     duration: 2000
    //   })
    //   setTimeout(() => {
    //     bus.$emit('goto', '/login')
    //   }, 2000);
    // } else if (error.response.status == '401') {
    //   Toast({
    //     message: error.response.data.data,
    //     duration: 2000
    //   })
    //   setTimeout(() => {
    //     bus.$emit('goto', '/login')
    //   }, 2000);
    // } else {
    //   Toast({
    //     message: error.response.data.data || '请求失败',
    //     duration: 2000
    //   })
    // }
    // setTimeout(() => {
    //   bus.$emit('goto', '/login')
    // }, 2000);
    return Promise.reject(error.response.data.data) // 返回接口返回的错误信息
  }
)
// {"ret":0,"msg":"session_permission","data":"权限不足"}     给用户提示
// {"ret":0,"msg":"session_force_off","data":"已经在另一台机器登录，您被迫下线。"} 给用户提示然后 跳转登录页面
// {"ret":0,"msg":"session_invalid","data":"会话已过期，请刷新"} 跳转登录页面

export const POSTJSON = (url, params) => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: params,
    url,
  }
  return axios(options).then(res => res.data)
}
export const POST = (url, params, toast = false, _JSON = 'form') => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': _JSON == 'form' ? 'application/x-www-form-urlencoded;charset=UTF-8' : _JSON
    },
    data: _JSON == 'form' ? qs.stringify(params) : params,
    url,
  }
  if (toast) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    });
  }
  return new Promise((resolve, reject) => {
    axios(options).then(res => {
      Toast.clear()
      resolve(res.data)
    })
  })
  // return axios(options).then(res => res.data)
}
export const POSTIMG = (url, data) => {
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data,
    url,
  }
  return axios(options).then(res => res.data)
}

export const GET = (url, params, toast = false) => {
  const options = {
    method: 'GET',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    params: params,
    url: url,
  }
  if (toast) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    });
  }
  return new Promise((resolve, reject) => {
    axios(options).then(res => {
      Toast.clear()
      resolve(res.data)
    })

  })


  // return axios.get(`${url}`, { params: params }).then(res => res.data)
}

export const PUT = (url, params) => {
  return axios.put(`${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return axios.delete(`${url}`, {
    params: params
  }).then(res => res.data)
}

export const PATCH = (url, params) => {
  return axios.patch(`${url}`, params).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js